import { FC } from 'react';
import { Flex, Spacer } from '@chakra-ui/react';
import { isNil } from 'ramda';

import { formatAmount } from 'common/formatAmount';
import formatPercent from 'common/formatPercent';
import SunshineCard from 'components/_core/SunshineCard';
import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';
import type { DetailedTransactionReceipt } from 'features/Bank/pages/Overview/Sidebar/hooks/useDetailedTransactionQuery';

import locales from './locales';

type DisplayVatProps = {
  vatAmountItems: NonNullable<
    DetailedTransactionReceipt['vatAmount']
  >['vatAmountItems'];
  onEdit: () => void;
} & React.ComponentProps<typeof SunshineCard>;

const DisplayVat: FC<DisplayVatProps> = ({
  onEdit,
  vatAmountItems,
  ...props
}) => (
  <SunshineCard alignItems="center" onClick={onEdit} {...props}>
    <SunshineCard.Content alignItems="stretch" spacing="space-16">
      <SunshineCard.Title alignItems="center" display="flex">
        {locales.title}
        <Spacer />
        <SunshineIcon name="edit" />
      </SunshineCard.Title>

      <>
        {vatAmountItems.map((item) =>
          !isNil(item.trueVatRate) && !isNil(item.trueVatAmount) ? (
            <Flex
              borderTopColor="grey.2"
              borderTopWidth={1}
              justifyContent="space-between"
              key={item.vatAmountItemId}
              paddingTop="space-16"
            >
              <Text>{`${locales.vat} ${formatPercent(item.trueVatRate)}`}</Text>
              <Text variant="primary">
                {formatAmount({
                  forcePlusSign: false,
                  value: item.trueVatAmount,
                })}
              </Text>
            </Flex>
          ) : null,
        )}
      </>
    </SunshineCard.Content>
  </SunshineCard>
);

export default DisplayVat;
